/* eslint-disable no-unused-vars */
import React from 'react';
import styled, { css } from 'styled-components';
import { Palette } from 'config';

const NothingSelected = () => {
  return (
    <Container>
      <span>Nothing Selected</span>
    </Container>
  );
};

export default NothingSelected;

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${Palette.PrimaryGray._100};
  height: 389px;
  span {
    color: ${Palette.PrimaryGray._500};
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
  }
`;
